import { Qualifier } from './Qualifier';
import { IQualifier } from './IQualifier';
import CreditOrDebitPosTransactionTypes from './CreditOrDebitPosTransactionTypes';

export class CreditOrDebitCardQualifier extends Qualifier {
    public static readonly CLASS: string = 'com.bancvue.rcx.config.product.qualifiers.api.CreditOrDebitCardQualifier';

    public static readonly NAME: string = 'Credit Card or POS Transactions';


    transactionType: string = CreditOrDebitPosTransactionTypes.POS_CC.value;

    minimumTransactionCount: number = 0;

    minimumTransactionAmount: number = 0;

    constructor(qual?: IQualifier) {
      super(CreditOrDebitCardQualifier.CLASS, qual ? qual.id : null);

      if (qual) {
        this.transactionType = (qual as any).transactionType;
        this.minimumTransactionCount = (qual as any).minimumTransactionCount;
        this.minimumTransactionAmount = (qual as any).minimumTransactionAmount;
      }
    }

    getDescription(): string {
      switch (this.transactionType) {
        case 'POS_CC':
          return `${this.minimumTransactionCount} CC or POS transaction(s) of at least $${this.minimumTransactionAmount}`;
        case 'POS_PIN_CC':
          return `${this.minimumTransactionCount} CC or POS PIN transaction(s) of at least $${this.minimumTransactionAmount}`;
        case 'POS_SIGNATURE_CC':
          return `${this.minimumTransactionCount} CC or POS Signature transaction(s) of at least $${this.minimumTransactionAmount}`;
        default:
          return 'Invalid CC or POS qualifier';
      }
    }

    clone(): IQualifier {
      const clone = new CreditOrDebitCardQualifier();
      Object.assign(clone, this);
      return clone;
    }
}

export default CreditOrDebitCardQualifier;
